module.exports = __webpack_public_path__ + "img/IMG_8733.622a01ae.jpg";